import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import _defineProperty from "/Users/yangwei/work/project/cat_help_admin/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import settingSlot from "./settingSlot";
import MaterialList from '@/components/material/list.vue';
import AppPageSelect from '@/components/app-page-select/Index.vue';
import bgColorSelect from "../pages/page-components/bgColorSelect";
import draggable from "vuedraggable";
export default {
  components: {
    draggable: draggable,
    settingSlot: settingSlot,
    MaterialList: MaterialList,
    AppPageSelect: AppPageSelect,
    bgColorSelect: bgColorSelect
  },
  data: function data() {
    return {
      formDataCopy: {
        swiperType: 'screen-swiper',
        dotStyle: 'square-dot',
        background: 'red',
        height: 100,
        interval: 3000,
        borderRadius: 0,
        imageSpacing: 0,
        swiperList: [{
          id: Math.random(),
          imageUrl: '',
          imgWidth: 0,
          imgHeight: 0,
          pageUrl: '',
          itemTitle: ''
        }]
      },
      formData: {
        background: ''
      },
      showBgDialog: false,
      colorList: [{
        title: '默认',
        name: 'gradual-scarlet',
        color: '#ffffff'
      }, {
        title: '嫣红',
        name: 'red',
        color: '#e54d42'
      }, {
        title: '桔橙',
        name: 'orange',
        color: '#f37b1d'
      }, {
        title: '明黄',
        name: 'yellow',
        color: '#fbbd08'
      }, {
        title: '橄榄',
        name: 'olive',
        color: '#8dc63f'
      }, {
        title: '森绿',
        name: 'green',
        color: '#39b54a'
      }, {
        title: '天青',
        name: 'cyan',
        color: '#1cbbb4'
      }, {
        title: '海蓝',
        name: 'blue',
        color: '#0081ff'
      }, {
        title: '深蓝',
        name: 'darkblue',
        color: '#0055ff'
      }, {
        title: '姹紫',
        name: 'purple',
        color: '#6739b6'
      }, {
        title: '木槿',
        name: 'mauve',
        color: '#9c26b0'
      }, {
        title: '桃粉',
        name: 'pink',
        color: '#e03997'
      }, {
        title: '棕褐',
        name: 'brown',
        color: '#a5673f'
      }, {
        title: '玄灰',
        name: 'grey',
        color: '#8799a3'
      }, {
        title: '草灰',
        name: 'gray',
        color: '#aaaaaa'
      }, {
        title: '墨黑',
        name: 'black',
        color: '#333333'
      }, {
        title: '雅白',
        name: 'white',
        color: '#ffffff'
      }, {
        title: '粉红',
        name: 'gradual-red',
        color: '#ffffff'
      }, {
        title: '橙红',
        name: 'gradual-orange',
        color: '#ffffff'
      }, {
        title: '绿青',
        name: 'gradual-green',
        color: '#ffffff'
      }, {
        title: '紫红',
        name: 'gradual-purple',
        color: '#ffffff'
      }, {
        title: '粉紫',
        name: 'gradual-pink',
        color: '#ffffff'
      }, {
        title: '蓝绿',
        name: 'gradual-blue',
        color: '#ffffff'
      }, {
        title: '黑灰',
        name: 'gradual-gray',
        color: '#ffffff'
      }, {
        title: '淡蓝',
        name: 'gradual-darkblue',
        color: '#ffffff'
      }, {
        title: '默认',
        name: 'scarlet',
        color: '#ffffff'
      }]
    };
  },
  props: {
    clientType: [String],
    thememobile: {
      type: Object | Array
    },
    showData: {
      type: Object,
      default: function _default() {}
    },
    config: {
      type: Object,
      default: function _default() {}
    }
  },
  computed: _objectSpread({}, mapState({
    componentsList: function componentsList(state) {
      return state.divpage.componentsList;
    },
    clickComIndex: function clickComIndex(state) {
      return state.divpage.clickComIndex;
    }
  })),
  mounted: function mounted() {
    var that = this;
    if (that.IsEmptyObj(that.showData)) {
      that.formData = JSON.parse(JSON.stringify(that.formDataCopy));
    } else {
      that.formData = that.showData;
    }
    that.$set(that.componentsList[that.clickComIndex], 'data', this.formData);
    // that.updateData({
    //   componentsList: that.componentsList
    // })
  },

  methods: _objectSpread(_objectSpread({}, mapMutations(['updateData'])), {}, {
    onBgColor: function onBgColor(item) {
      this.formData.background = 'bg-' + item.name;
      this.showBgDialog = false;
    },
    // 添加图片
    addCarouselItem: function addCarouselItem() {
      var that = this;
      that.pushImgs();
    },
    pushImgs: function pushImgs() {
      var that = this;
      if (that.formData.swiperList.length >= 10) {
        that.$message.error("图片不能超过10张");
        return false;
      }
      that.formData.swiperList.push({
        id: Math.random(),
        imageUrl: '',
        imgWidth: 0,
        imgHeight: 0,
        pageUrl: '',
        itemTitle: ''
      });
    },
    // 删除轮播图片
    delCarouselItem: function delCarouselItem(index) {
      var that = this;
      if (that.formData.swiperList.length <= 1) {
        that.$message.error("请至少保留一张图片");
        return false;
      }
      that.$confirm('是否删除该图片?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        that.$delete(that.formData.swiperList, index);
      }).catch(function () {});
    },
    // 删除按钮
    delBtn: function delBtn(index) {
      var that = this;
      that.$confirm('是否删除该组件?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        that.$delete(that.componentsList[that.clickComIndex].data.itemArray, index);
        that.updateData({
          componentsList: that.componentsList
        });
      }).catch(function () {});
    },
    cancel: function cancel() {
      this.$emit('cancel');
    },
    reset: function reset() {
      var that = this;
      that.formData = JSON.parse(JSON.stringify(that.formDataCopy));
      that.componentsList[that.clickComIndex]['data'] = this.formData;
    },
    confirm: function confirm() {
      this.$emit('confirm', this.formData);
    },
    delete: function _delete() {
      this.$emit('delete');
    }
  }),
  watch: {
    showData: {
      handler: function handler(newVal, oldVal) {
        this.formData = newVal ? newVal : this.formData;
      },
      deep: true
    }
  }
};